declare namespace $ {

	export class $mol_icon_skip_next extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=next.view.tree.d.ts.map